import React from 'react';
import { Truncate as EmotionTruncate, TruncateLeft as EmotionTruncateLeft, TruncateRight as EmotionTruncateRight } from './truncateText-emotion';
import { Truncate as CompiledTruncate, TruncateLeft as CompiledTruncateLeft, TruncateRight as CompiledTruncateRight } from './truncateText-compiled';
import { fg } from '@atlaskit/platform-feature-flags';
export var Truncate = function Truncate(props) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledTruncate, props) : /*#__PURE__*/React.createElement(EmotionTruncate, props);
};
export var TruncateLeft = function TruncateLeft(props) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledTruncateLeft, props) : /*#__PURE__*/React.createElement(EmotionTruncateLeft, props);
};
export var TruncateRight = function TruncateRight(props) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledTruncateRight, props) : /*#__PURE__*/React.createElement(EmotionTruncateRight, props);
};
export { calculateTruncation } from './truncateText-compiled';